import { render } from "./App.vue?vue&type=template&id=d6157336"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=d6157336&lang=css"

import exportComponent from "D:\\tinygeeker.com\\perfectSitemap\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__